<footer data-id="neptune-footer" class="w-full fixed bottom-0 left-0 z-20 bg-blue">
  <div class="flex items-center justify-between px-6 py-3 text-white">
    <span class="text-sm">© Ecolab 2024</span>
    <div class="links">
      <span class="text-white">|</span>
      <a data-id="privacy-policy-link" href="https://www.ecolab.com/privacy-policy" target="_blank" rel="noopener noreferrer">Privacy Policy</a>
      <span class="text-white">|</span>
      <a data-id="terms-of-use-link" href="https://www.ecolab.com/terms-of-use" target="_blank" rel="noopener noreferrer">Terms of Use</a>
      <span class="text-white">|</span>
    </div>
    <img src="assets/logo.svg" alt="Ecolab logo" data-id="neptune-footer-logo" class="h-6 brightness-0 invert" />
  </div>
</footer>
